module.exports = __webpack_public_path__ + "img/a202583c07d5b1673cd316168a65bb0b.png";